import { convertFromRaw } from 'draft-js';
import { stateToHTML } from 'draft-js-export-html';

export const convertFromJsonOrReturnValue = (value) => {
  try {
    JSON.parse(value);
    return convertFromRaw(JSON.parse(value));
  } catch (e) {
    return value;
  }
};

export const isJson = (value) => {
  try {
    const parsed = JSON.parse(value);
    // Check if the result is an object or array (but not null, since typeof null is "object")
    // Also, JSON.parse("number") = number, it does not throw error
    return (
      (typeof parsed === 'object' && parsed !== null) || Array.isArray(parsed)
    );
  } catch (e) {
    return false;
  }
};

export const convertToHtml = (value) => {
  if (!value || typeof value !== 'string') {
    return '';
  }
  try {
    return stateToHTML(convertFromRaw(JSON.parse(value)));
  } catch (e) {
    // If JSON parsing fails, treat as plain text
    return value;
  }
};

export const convertToText = (value) => {
  if (!value || typeof value !== 'string') {
    return '';
  }
  try {
    return convertFromJsonOrReturnValue(JSON.parse(value))
      .blocks.map((block) => (!block.text.trim() && '\n') || block.text)
      .join('\n');
  } catch (e) {
    // If JSON parsing fails, treat as plain text
    return value;
  }
};
